import { render, staticRenderFns } from "./index.vue?vue&type=template&id=387b3daa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=387b3daa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b3daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387b3daa')) {
      api.createRecord('387b3daa', component.options)
    } else {
      api.reload('387b3daa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=387b3daa&scoped=true", function () {
      api.rerender('387b3daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/fan_soft_report/index.vue"
export default component.exports